import React, { useCallback, useRef, useState } from "react";
import {
  I2cBrand,
  I2cButton,
  I2cInput,
  I2cIcon,
  I2cPasswordField,
} from "@webcomponents/i2cwebcomponents/dist/react";
import AsideSection from "../../Components/AsideSection/AsideSection";
// @ts-expect-error
import logo from "../../assets/images/i2c_logo.svg";
// @ts-expect-error
import banner from "../../assets/images/login_art.svg";
import { useNavigate } from "react-router-dom";
import { GoogleReCaptcha } from "react-google-recaptcha-v3";
import AuthHeadDesc from "../../Components/SharedComponent/AuthHeaderSection/AuthHeaderSection";
import { useForm, Controller } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import ErrorMessage from "../../Components/SharedComponent/ErrorMessage/ErrorMessage";
import { passwordValidationSchema } from "../Auth/ResetPassword/ValidationSchema";
import { useMutation } from "react-query";
import AuthService from "../../Services/AuthServices";
import "../../Utils/shared-styles/Authentication.scss";
import AlertMessage from "../../Components/SharedComponent/Alert/Alert";
import { UserStateContext } from "../../Context/AuthContext";
import "./SetPassword.scss";
const SetPassword = () => {
  const form = useRef();
  const navigate = useNavigate();
  const AuthContext = UserStateContext();
  const [recaptcha, setRecaptcha] = useState("");
  const [reValidateRecaptcha, setReValidateRecaptcha] = useState(false);

  // eslint-disable-next-line no-unused-vars
  const [passwordValidator, setPasswordValidator] = useState("");

  // Reset password mutation
  const setPassword = useMutation({
    mutationFn: async (values) => {
      return await AuthService.setPassword({
        ...values,
        recaptcha,
      });
    },
    onSuccess: (data) => {
      AuthContext.setIsTempPwd(false);
      // Check for redirect URL from sessionStorage
      const redirectUrl = sessionStorage.getItem('redirectAfterLogin');
      if (redirectUrl) {
        sessionStorage.removeItem('redirectAfterLogin');
        navigate(redirectUrl);
      } else {
        if (AuthContext.userRole === 5 || AuthContext.userRole === '5' || AuthContext.roleName === 'client') {
          navigate(`/impl`);
        } else {
          navigate(`/sales`);
        }
      }
    },
    onError: () => {
      setReValidateRecaptcha(true);
    },
  });

  const resetPasswordError = setPassword.error;

  // FormEventHandler<HTMLFormElement>
  const handleSubmitForm = (e) => {
    if (recaptcha) {
      setPassword.mutate(e);
    } else {
    }
  };

  // To stop the continous calling of verification of google recaptcha
  const onVerify = useCallback((token) => {
    setReValidateRecaptcha(false);
    setRecaptcha(token);
  }, []);
  // Hook form initialization and methods
  const methods = useForm({
    resolver: zodResolver(passwordValidationSchema),
    mode: "onChange",
    reValidateMode: "onChange",
    shouldUseNativeValidation: false,
    criteriaMode: "firstError",
    defaultValues: {
      password: "",
      password_confirmation: "",
    },
  });

  // Hook form methods destructuring
  const {
    handleSubmit,
    formState: { errors },
  } = methods;

  return (
    <React.Fragment>
      <div className="layout_aside">
        <div className="layout_aside-left">
          <AsideSection
            image={banner}
            heading={"Commitment to delivering exceptional solutions"}
            description={
              "customer-centric approach and dedication to driving success through seamless implementations"
            }
          />
        </div>
        <div className="layout_aside-right forStandAlone">
          <div className="right-container">
            <div className="login  auth__main-right">
              <div className="auth__right-content">
                <div className="login__content-wrapper auth__content-wrapper">
                  <header id="header">
                    <I2cBrand
                      className="login__logo"
                      label="Client Implementation Portfolio"
                      logo={logo}
                      target=""
                    ></I2cBrand>
                  </header>
                  <AuthHeadDesc
                    title="Create New Password"
                    description="Please choose a strong and secure password for your account."
                  />
                  <div className="login__form">
                    <AlertMessage
                      open={setPassword.isError}
                      message={
                        resetPasswordError?.response?.errors?.password[0] ??
                        resetPasswordError?.response?.message
                      }
                    />
                    {setPassword?.data?.data?.message && (
                      <AlertMessage
                        open={true}
                        variant="success"
                        closeAble
                        headerArt={"linear-tick-circle"}
                        message={setPassword.data.data.message}
                      />
                    )}
                    <form
                      onSubmit={handleSubmit(handleSubmitForm)}
                      ref={form}
                      autoComplete="on"
                    >
                      <div className="">
                        <Controller
                          name="password"
                          control={methods.control}
                          render={({ field }) => (
                            // <I2cInput
                            //   size="large"
                            //   label="Create Password"
                            //   type="password"
                            //   placeholder="Password@123"
                            //   name="password"
                            //   className={`auth__custom-input`}
                            //   required
                            //   invalid={false}
                            //   onI2cInput={(e) => {
                            //     field.onChange(e.target.value ?? "");
                            //     setPasswordValidator(e.target.value ?? "");
                            //   }}
                            //   onI2cBlur={field.onBlur}
                            //   togglePassword={true /* passIcon */}
                            // >
                            //   <I2cIcon
                            //     slot="hide-password-icon"
                            //     name={"linear-eye"}
                            //   />
                            //   <I2cIcon
                            //     slot="show-password-icon"
                            //     name={"linear-eye-slash"}
                            //   />
                            // </I2cInput>
                            <I2cPasswordField
                              name="password"
                              className="auth__custom-input"
                              onI2cChange={(e) => {
                                field.onChange(e.target.value ?? "");
                                setPasswordValidator(e.target.value ?? "");
                              }}
                              toggle-password
                              placeholder="Password@123"
                              label="Create Password"
                              pattern="^(?=.*[0-9])(?=.*[A-Z])(?=.*[^a-zA-Z0-9]).{8,}$"
                              required
                              autofocus
                              errorMessageVisible={true}
                              togglePassword={true}
                              strength-box
                              size="large"
                              conditions={[
                                {
                                  text: "Special character",
                                  srOnlyText: "1 Special Character",
                                  regexValue: ".*[^a-zA-Z0-9].*",
                                  status: false,
                                },
                                {
                                  text: "Minimum 13 characters",
                                  srOnlyText:
                                    "password length should be minimum 13 characters",
                                  regexValue: "^.{13,}$",
                                  status: false,
                                },
                                {
                                  text: "Number",
                                  srOnlyText: "1 Number",
                                  regexValue: ".*[0-9].*",
                                  status: false,
                                },
                                {
                                  text: "Capital Letter",
                                  srOnlyText: "! Capital ",
                                  regexValue: "[A-Z]",
                                  status: false,
                                },
                              ]}
                            >
                              <I2cIcon
                                slot="hide-password-icon"
                                name={"linear-eye-slash"}
                              />
                              <I2cIcon
                                slot="show-password-icon"
                                name={"linear-eye"}
                              />

                            </I2cPasswordField>
                          )}
                        />
                      </div>
                      {/* <PasswordValidator
                        passwordValidator={passwordValidator}
                      /> */}
                      <div className="set-new-password-fields-spacing"></div>
                      <div className="login__form-group field-group">
                        <Controller
                          name="password_confirmation"
                          control={methods.control}
                          render={({ field }) => (
                            <I2cInput
                              size="large"
                              type="password"
                              label="Confirm Password"
                              placeholder="Password@123"
                              name="password_confirmation"
                              className={`auth__custom-input`}
                              required
                              invalid={
                                errors.password_confirmation ? true : false
                              }
                              togglePassword={true /* passIcon */}
                              onI2cInput={field.onChange}
                              onI2cBlur={field.onBlur}
                            >
                              <I2cIcon
                                slot="hide-password-icon"
                                name={"linear-eye"}
                              />
                              <I2cIcon
                                slot="show-password-icon"
                                name={"linear-eye-slash"}
                              />
                            </I2cInput>
                          )}
                        />
                        <ErrorMessage
                          show={errors.password_confirmation ? true : false}
                          message={
                            errors.password_confirmation?.message ??
                            "Invalid input"
                          }
                        />
                      </div>
                      <GoogleReCaptcha
                        onVerify={onVerify}
                        refreshReCaptcha={reValidateRecaptcha}
                      />
                      <div className="confirmed-action-acion-button-reset-success">
                        <I2cButton
                          variant="secondary gray"
                          size={"medium"}
                          className="login__sign-btn fw-500"
                          style={{
                            width: "48%",
                          }}
                          onClick={() => {
                            localStorage.removeItem("token");
                            localStorage.removeItem("session");
                            localStorage.removeItem("sessionCount");
                            navigate("/login");
                          }}
                        >
                          Cancel
                        </I2cButton>
                        <I2cButton
                          destructive={false}
                          className="login__sign-btn"
                          size={"medium"}
                          style={{ width: "48%" }}
                          disabled={!methods.formState.isValid}
                          loading={setPassword.isLoading}
                          onClick={() => handleSubmitForm(methods.getValues())}
                        >
                          Submit
                        </I2cButton>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <footer className="login__footer_mobile">
            <p className="login-aside__footer-text">
              i2c Inc. &copy; {new Date().getFullYear()} All Rights Reserved.
            </p>
          </footer>
        </div>
      </div>
    </React.Fragment>
  );
};

export default SetPassword;
